import React from "react";
import { Controller, Control, FieldErrors } from "react-hook-form";
import { Label } from "@/components/ui/label";
import { TranslationType, FormValues } from "../types";

interface GenderFieldProps {
  control: Control<FormValues>;
  errors: FieldErrors<FormValues>;
  t: TranslationType;
}

export const GenderField = ({ control, errors, t }: GenderFieldProps) => {
  return (
    <div className="space-y-3">
      <Label>{t.genderAtBirth}</Label>
      <Controller
        name="genderAtBirth"
        control={control}
        rules={{ required: true }}
        render={({ field }) => (
          <>
            <div className="flex flex-row gap-6">
              <div className="flex items-center gap-3">
                <label
                  htmlFor="male"
                  className="flex items-center gap-3 cursor-pointer group"
                >
                  <div className="relative">
                    <input
                      type="radio"
                      id="male"
                      value="male"
                      checked={field.value === "male"}
                      onChange={() => field.onChange("male")}
                      onBlur={field.onBlur}
                      className="peer absolute opacity-0 w-5 h-5 cursor-pointer"
                      autoComplete="sex"
                      tabIndex={0}
                    />
                    <div
                      className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all duration-200 peer-focus:ring-2 peer-focus:ring-black peer-focus:ring-offset-2 ${
                        field.value === "male"
                          ? "border-transparent"
                          : "border-gray-300 group-hover:border-gray-400"
                      }`}
                      style={{
                        background:
                          field.value === "male"
                            ? "linear-gradient(135deg, #4C2652 0%, #5C4279 100%)"
                            : "transparent",
                      }}
                    >
                      {field.value === "male" && (
                        <div className="w-2 h-2 bg-white rounded-full"></div>
                      )}
                    </div>
                  </div>
                  <span className="text-sm font-medium select-none">
                    {t.male}
                  </span>
                </label>
              </div>

              <div className="flex items-center gap-3">
                <label
                  htmlFor="female"
                  className="flex items-center gap-3 cursor-pointer group"
                >
                  <div className="relative">
                    <input
                      type="radio"
                      id="female"
                      value="female"
                      checked={field.value === "female"}
                      onChange={() => field.onChange("female")}
                      onBlur={field.onBlur}
                      className="peer absolute opacity-0 w-5 h-5 cursor-pointer"
                      autoComplete="sex"
                      tabIndex={0}
                    />
                    <div
                      className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all duration-200 peer-focus:ring-2 peer-focus:ring-black peer-focus:ring-offset-2 ${
                        field.value === "female"
                          ? "border-transparent"
                          : "border-gray-300 group-hover:border-gray-400"
                      }`}
                      style={{
                        background:
                          field.value === "female"
                            ? "linear-gradient(135deg, #4C2652 0%, #5C4279 100%)"
                            : "transparent",
                      }}
                    >
                      {field.value === "female" && (
                        <div className="w-2 h-2 bg-white rounded-full"></div>
                      )}
                    </div>
                  </div>
                  <span className="text-sm font-medium select-none">
                    {t.female}
                  </span>
                </label>
              </div>
            </div>

            {errors.genderAtBirth && (
              <span className="text-sm text-red-500">{t.genderRequired}</span>
            )}
          </>
        )}
      />
    </div>
  );
};
